export default {
  home: "首页",
  news: "新闻资讯",
  product: "产品中心",
  upgrade: "升级通知",
  about: "关于我们",
  feedback: "反馈",
  support: "技术支持",
  personal: "个人中心",
  userCenter: "个人中心",
  login: "登录",
  register: "注册",
  layout: "退出",
  classify: "产品分类",
  manualClassify: "维修手册分类",
  videoClassify: "维修视频分类",
  guide: "维修指引",
  manual: "维修手册",
  video: "维修视频",
  download: "下载",
  name: "产品名称",
  date: "产品日期",
  updateDate: "更新日期",
  info: "更新信息",
  type: "产品型号",
  sn: "产品SN",
  upgradeImmediately: "马上升级",
  resetPassword: "重置密码",
  submit: "提交",
  code: "验证码",
  getCode: "获取验证码",
  email: "邮箱",
  emailNew: "新邮箱",
  tel: "联系电话",
  password: "密码",
  newPassword: "新密码",
  forgetPassword: "忘记密码",
  userName: "账号",
  introduce: "企业介绍",
  contactUs: "联系我们",
  issueName: "手册名称",
  issueDate: "发布日期",
  videoName: "视频名称",
  tipsSn: "请到个人中心添加设备号",
  tipsSearch: "必须输入搜索文字",
  synopsis: "维修说明书",
  synopsisClassify: "维修说明书分类",
  tipsLogin: "需要登录",
  professionalServices: "专业的服务",
  professionalServicesText: "由专业领域十年以上人员 负责疑难问题和故障受理",
  strongTechnicalAbility: "技术能力强",
  strongTechnicalAbilityText:
    "运用多种技术，发挥团队力量，帮助客户进行调试、解决故障",
  focusOnCustomerServices: "专注客户服务",
  focusOnCustomerServicesText:
    "利用企业微信提供在线解答 帮助企业快速准确解决问题和故障",
  worryfreeMaintenanceOfIterativeWarranty: "维护迭代质保无忧",
  worryfreeMaintenanceOfIterativeWarrantyText:
    "对项目统一管理 由技术支持工程师，负责问题解答",
  indextitle: "为什么选择我们的服务",
  emailRegister: "邮箱注册",
  mobileRegister: "手机注册",
  search: "搜索",
  searchTips: "请输入搜索关键词",
  serviceTitle: "故障码维修信息查询",
  vehicleBrands: "车辆品牌",
  year: "年款",
  carModel: "车型",
  electricSystem: "电控系统",
  ecu: "ECU类型",
  searchContent: "请输入搜索内容",
  myProfile: "账户信息",
  myOrders: "我的订单",
  mySN: "设备序列号",
  edit: "修改",
  phone: "电话",
  account: "账号",
  add: "添加",
  tipSn: "请输入设备序列号",
  dates: "日期",
  infos: "信息",
  price: "价格",
  deviceNumber: "设备号",
  payStatus: "支付状态",
  edits: "操作",
  downloads: "下载文件",
  paymentMethod: "请选择支付方式",
  amount: "金额",
  changeTheTel: "修改手机",
  changeThePassword: "修改密码",
  changeTheEmail: "修改邮箱",
  oldPhone: "旧电话号码",
  newPhone: "新电话号码",
  oldEmail: "旧邮箱",
  moblieText: "只能使用中国手机号注册"
};
